
const EditorFeatureReportItem = ({ label, appearence }) => {
	return (
		<div className='flex lg:py-4 2xl:py-5 lg:px-5 2xl:px-6 rounded-lg border border-db items-center'>
			<h5 className='2xl:text-xl font-bold leading-7 text-1b'>{label}</h5>
			<div className='ml-auto flex items-center 2xl:text-lg font-normal text-7d'>
				<span>Appeared</span>
				<span className='bg-ffa text-white lg:mx-3 2xl:mx-4 lg:w-7 2xl:w-9 lg:h-7 2xl:h-9 rounded-full grid place-items-center'>{appearence}</span>
				<span>Times</span>
			</div>
		</div>
	)
}

export default EditorFeatureReportItem